import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import localStorageAvailable from '../../utils/localStorageAvailable';

// ----------------------------------------------------------------------
const base_url = '/v1/applicantdata';

const initialState = {
  isLoading: false,
  error: null,
  applicantdatas: [],
  applicantdata: null,
};

const slice = createSlice({
  name: 'myprofile',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ALL
    getrecAppData(state, action) {
      state.isLoading = false;
      state.applicantdatas = action.payload;
    },

    // GET ONE
    getOnerecAppData(state, action) {
      state.isLoading = false;
      state.applicantdata = action.payload;
    },

    // CREATE
    createrecAppData(state, action) {
      const newdata = action.payload;
      state.isLoading = false;
      state.applicantdatas = [...state.applicantdatas, newdata];
    },

    // UPDATE
    updaterecAppData(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function get() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const storageAvailable = localStorageAvailable();
      const username = storageAvailable ? localStorage.getItem('applicant_id') : '';            
      
      const response = await axios.get(`${base_url}/${username}`);
      console.log(response.data.data);
      dispatch(slice.actions.getOnerecAppData(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getByApplicant() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const storageAvailable = localStorageAvailable();
      const username = storageAvailable ? localStorage.getItem('applicant_id') : '';            
      
      const response = await axios.get(`${base_url}/${username}`);
      
      dispatch(slice.actions.getOnerecAppData(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/applicantdata`);
      dispatch(slice.actions.getOnerecAppData(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getByDescription(description) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${description}`);
      dispatch(slice.actions.getOnerecAppData(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function create(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}`, newData);
      dispatch(slice.actions.createrecAppData(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
export function createEmp(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}/employment`, newData);
      dispatch(slice.actions.createrecAppData(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function update(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`${base_url}`, data);
      dispatch(slice.actions.updaterecAppData(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`${base_url}?id=${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
